module.exports = __webpack_public_path__ + "img/viva.03264fc8.png";